import {isJqueryElement} from "./wvn_exist";
import responsive from "./wvn_responsive";

var slider = {
  banner : function (elementHtmlTag) {
    var options = _sliderPrivate.getDefaultOption(elementHtmlTag);
    options.fade = true;
    options.autoplay = true;
    options.slidesToShow = 1;

    jQuery(elementHtmlTag).find('.slider--items').slick(options);
  },
  hpNewNEvent : function (elementHtmlTag) {
    var options = _sliderPrivate.getDefaultOption(elementHtmlTag);
    options.autoplay = true;
    options.infinite = true;
    options.centerMode = true;
    options.variableWidth = true;
    options.responsive = [
      {
        breakpoint: responsive.screens.xs.maxWidth,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
        }
      }
    ];

    jQuery(elementHtmlTag).find('.slider--items').slick(options);
  },
  hpJob : function (elementHtmlTag) {
    var options = _sliderPrivate.getDefaultOption(elementHtmlTag);
    options.autoplay = true;
    options.centerMode = true;
    options.variableWidth = true;
    options.infinite = true;
    options.responsive = [
      {
        breakpoint: responsive.screens.xs.maxWidth,
        settings: {
          slidesToShow: 1,
          variableWidth: false,
        }
      }
    ];

    jQuery(elementHtmlTag).find('.slider--items').slick(options);
  },
  footerPartner : function (elementHtmlTag) {
    var options = _sliderPrivate.getDefaultOption(elementHtmlTag);
    options.autoplay = true;
    options.infinite = true;
    options.centerMode = true;
    options.variableWidth = true;

    jQuery(elementHtmlTag).find('.slider--items').slick(options);
  },
};

var _sliderPrivate = {
  getDefaultOption : function (elementHtmlTag) {
    var options = {
      accessibility: true,
      arrows: false,
      dots: false,
      fade: false,
      autoplay: false,
      autoplaySpeed: 3000,
      infinite: false,
      zIndex: 0,
    };

    var nextArrow = jQuery(elementHtmlTag).find('.slider--next');
    var prevArrow = jQuery(elementHtmlTag).find('.slider--prev');

    if (isJqueryElement(nextArrow) && isJqueryElement(prevArrow)) {
      options.arrows = true;
      options.nextArrow = nextArrow;
      options.prevArrow = prevArrow;
    }

    return options;
  }
};

export default slider;
